<template>
  <div class="flex w-full flex-col items-center gap-[12px]">
    <div class="w-full pb-[12px]">
      <h2 class="text-center text-[28px] font-bold leading-[1.3] text-[#3a3d44]">
        {{ hasChoice ? "Привязка мессенджера" : "Привязка Telegram" }}
      </h2>
    </div>

    <p class="w-[368px] text-center text-sm text-[#3A3D44]/60 max-md:w-full max-md:px-4">
      {{ hint }}
    </p>

    <!-- Переключатель нужен, только когда доступен не один мессенджер -->
    <div v-if="hasChoice" class="flex w-[368px] gap-2 max-md:w-full max-md:px-4">
      <button
        v-for="option in bind.available"
        :key="option.value"
        type="button"
        class="flex flex-1 items-center justify-center gap-2 rounded-[12px] border py-3 text-base font-bold transition-colors"
        :class="
          bind.messenger.value === option.value
            ? 'border-primary bg-primary text-white'
            : 'border-[#E5EBF5] bg-white text-[#3a3d44] hover:border-primary/40'
        "
        @click="bind.start(option.value)"
      >
        <UINewIconsSocialITelegram
          v-if="option.value === 'telegram'"
          class="size-5 shrink-0"
          :color="bind.messenger.value === option.value ? '#fff' : '#3176FF'"
        />
        <UINewIconsSocialIMax
          v-else
          class="size-5 shrink-0"
          :color="bind.messenger.value === option.value ? '#fff' : '#3176FF'"
        />
        {{ option.label }}
      </button>
    </div>

    <a
      v-if="bind.authLink.value"
      :href="bind.authLink.value"
      target="_blank"
      class="flex w-[368px] items-center justify-center gap-2 rounded-[12px] bg-primary py-3 text-base font-bold text-white no-underline max-md:w-full"
    >
      <UINewIconsSocialITelegram
        v-if="bind.messenger.value === 'telegram'"
        class="size-6 shrink-0"
        color="#fff"
      />
      <UINewIconsSocialIMax v-else class="size-6 shrink-0" color="#fff" />
      Открыть {{ activeLabel }}
    </a>

    <div v-if="bind.isLoading.value" class="flex items-center gap-2 text-sm text-[#3A3D44]/60">
      <span class="loader-inline" />
      Ожидаем привязку...
    </div>

    <p
      v-if="bind.errorText.value"
      class="w-[368px] text-center text-sm text-[#f8465b] max-md:w-full max-md:px-4"
    >
      {{ bind.errorText.value }}
      <button
        v-if="bind.needsSupport.value"
        type="button"
        class="ml-1 text-primary underline"
        @click="openSupport"
      >
        Написать в поддержку
      </button>
    </p>

    <button
      class="cursor-pointer border-none bg-transparent text-sm text-primary"
      @click="$emit('close')"
    >
      Отмена
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { MessengerBindResult } from "~/services/AuthService";

  const emit = defineEmits<{
    (e: "bound", result: MessengerBindResult): void;
    (e: "close"): void;
  }>();

  const bind = useMessengerBind({ onBound: (result) => emit("bound", result) });
  // Шаг живёт в оформлении заказа — это кабинет рекламодателя
  const { openSupport } = useSupportLink("advertiser");

  const hasChoice = computed(() => bind.available.length > 1);
  const activeLabel = computed(
    () => bind.available.find((item) => item.value === bind.messenger.value)?.label || "Telegram"
  );

  const hint = computed(() =>
    hasChoice.value
      ? "Для создания заказа нужен привязанный аккаунт. Выберите мессенджер, перейдите в бот и нажмите Start."
      : "Для создания заказа необходимо привязать Telegram-аккаунт. Перейдите в бот и нажмите Start."
  );

  onMounted(() => bind.start("telegram"));
</script>
